import PropTypes from 'prop-types'
/*
 Mixin allows to manipulate tree state: save and restore.
 Tree state is saved when component is mounted and restored when unmounts.
 */

const mixin = {
  displayName: 'TreeStateManipulationMixin',

  childContextTypes: {
    saveTreeState: PropTypes.func,
    restoreTreeState: PropTypes.func,
  },

  getChildContext() {
    return {
      saveTreeState: this.saveTreeState,
      restoreTreeState: this.restoreTreeState,
    }
  },

  _savedTreeState: null,

  _getTreeCursor() {
    return this.props.tree || this.context.tree.select()
  },

  getTreeState() {
    return this._savedTreeState
  },

  saveTreeState() {
    this._savedTreeState = this._getTreeCursor().get()
  },

  restoreTreeState() {
    this._getTreeCursor().set(this._savedTreeState)
  },

  componentDidMount() {
    this.saveTreeState()
  },

  componentWillUnmount() {
    this.restoreTreeState()
  },
}

export default mixin
